<template>
  <div class="collectTioanListcontainer">
      <!-- 资料收集列表弹框 -->
        <!-- 表单勾选弹窗 -->
    <k-dialog
      class="collectTioanListDialog"
      ref = "collectionList"
      :options = "{title: '资料收集列表', center:true, width: '50%',height:900,top:'0',destroyOnClose:true,
      isCanClickClose: false,showClose: true,
      onCloseBefore: closeCollect,
      buttons:[{text:'确认', handler: closeCollect}]}">
        <!-- <div class="title">
          <div class="title-inner">
            资料收集列表
          </div>
           <div class="close" @click.stop="closeCollect">
              <span> <i class="el-icon-close"></i></span>
            </div>
        </div> -->
        <div class="update_main">
          <p class="list-tip">请仔细核对以下列表中业务表单的签字及盖章是否完善，以便后续业务顺利办理。</p>
          <div class="item">
              <div v-if="collectionListArr && collectionListArr.length > 0" class="rowClass">
                <template v-for="(item, index) in collectionListArr" >
                     <div class="list_item" :key="index">
                      <span>{{ item }}</span>
                    </div>
                 </template>
              </div>
          </div>
        </div>
    </k-dialog>
  </div>
</template>
<script>
import kDialog from "../../common/dialog.vue";

export default {
  components: {
    kDialog
  },
  props: {
    collectionList: {
      type: Array,
      default: false,
    }
  },
  data () {
    return {
      collectionListArr: []
    };
  },

  mounted () {
    this.collectionListArr = this.collectionList;
    this.$refs.collectionList.open();
  },
  methods: {
    closeCollect (){
      this.$emit("closeCollect");
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/styles/less/variable.less";

.collectTioanListcontainer{
  width: 100%;
  height: 100%;
  // display: flex;
  // align-items: center;
  // position: fixed;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // right: 0;
  // z-index: 5000;
  // background: rgba(55, 55, 55, .6);
  // &.no-mask {
  //   background: none;
  // }
  // .main-body{
  //   background: #e4e7ed;
  //   width: 100%;
  //   // position: absolute;
  //   // top: 50%;
  //   // left: 50%;
  //   // transform: translate(-50%, -50%);
  //   background-color: #fff;
  //   border: 0;
  //   border-radius: 6px;
  //   background-clip: padding-box;
  //   box-shadow: 0 4px 12px rgba(0,0,0,.15);
  //   // .title{
  //   //   border-bottom: 1px solid #e8eaec;
  //   //   padding: 0.14rem 0.16rem;
  //   //   line-height: 1;
  //   //   .title-inner{
  //   //     display: inline-block;
  //   //     width: 100%;
  //   //     height: auto;
  //   //     // line-height: .2rem;
  //   //     // font-size: .16rem;
  //   //     color: #17233d;
  //   //     // font-weight: 500;
  //   //     overflow: hidden;
  //   //     text-overflow: ellipsis;
  //   //     white-space: nowrap;
  //   //     .fontsize-title-small();
  //   //   }
  //   //   .close{
  //   //     z-index: 1;
  //   //     font-size: 0.20rem;
  //   //     position: absolute;
  //   //     right: 8px;
  //   //     top: 8px;
  //   //     overflow: hidden;
  //   //     cursor: pointer;
  //   //   }
  //   // }
  // }
  .update_main{
    // background: #e4e7ed;
    width: 100%;
    display: flex;
    flex-direction: column;
    .list-tip {
      // border-bottom: 1px solid #e8eaec;
      padding: 0.14rem 0.16rem;
      line-height: 1;
      font-weight: bold;
    }
    .item{
      .rowClass{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 0.3rem;
        margin-left: 0.07rem;
        .list_item {
          height: 0.4rem;
          line-height: 0.4rem;
          background: #f6f7f9;
          border: 0.5px solid #e4e7ed;
          border-radius: 2px;
          box-sizing: border-box;
          position: relative;
          margin-right: 0.1rem;
          padding-left: 0.05rem;
          width: 48.5%;
          .fontsize-text-medium();
          display: flex;
          align-items: center;
          line-height: 1.1;
          // span{
          //   font-size: .12rem !important;
          // }
        }
      }
    }
  }
}



</style>



// WEBPACK FOOTER //
// src/components/imageNode/child/collectionList.vue